export class EventService {
    constructor(serverConfig) {
        this.serverConfig = serverConfig;
    }
    onSave() {
        this.serverConfig.events.filter((events) => events.onSave).forEach((events) => events.onSave());
    }
    onSchemaBuilt(schema) {
        this.serverConfig.events.filter((events) => events.onSchemaBuilt).forEach((events) => events.onSchemaBuilt(schema));
    }
    onMongoConnected() {
        this.serverConfig.events.filter((events) => events.onMongoConnected).forEach((events) => events.onMongoConnected());
    }
}
